import React, { FC, Fragment } from 'react';

const MarketUpdater: FC = () => {
  return <Fragment></Fragment>;
};

export default MarketUpdater;
